// extracted by mini-css-extract-plugin
export default {"BaseHeading":"Headings__BaseHeading__tIA6B"};